import { ButtonDropdown } from '@cloudscape-design/components';
import type { ReactNode } from 'react';
import logoWhite from '../../assets/logo-white.svg';
import './TopNavigation.css';

interface TopNavigationProps {
  user?: {
    name: string;
    email: string;
  };
  onLogout: () => void;
  mobileNavToggle?: ReactNode;
}

export function TopNavigation({ user, onLogout, mobileNavToggle }: TopNavigationProps) {
  return (
    <header className="ttec-top-navigation" role="banner" aria-label="Site header">
      <div className="ttec-top-navigation__left">
        {mobileNavToggle && (
          <div className="ttec-top-navigation__mobile-toggle">
            {mobileNavToggle}
          </div>
        )}
        <div className="ttec-top-navigation__logo">
          <img src={logoWhite} alt="TTEC Digital" className="ttec-logo-image" />
        </div>
        <div className="ttec-top-navigation__title">
          Amazon Nova Sonic IVA & Agent Command Center
        </div>
      </div>
      
      <nav className="ttec-top-navigation__actions" aria-label="User menu">
        {user && (
          <ButtonDropdown
            items={[
              { id: 'profile', text: 'Profile' },
              { id: 'settings', text: 'Settings' },
              { id: 'logout', text: 'Logout' }
            ]}
            onItemClick={({ detail }) => {
              if (detail.id === 'logout') {
                onLogout();
              }
            }}
            variant="primary"
            ariaLabel={`User menu for ${user.name || user.email}`}
          >
            {user.name || user.email}
          </ButtonDropdown>
        )}
      </nav>
    </header>
  );
}
